// Source tracking utility for QR code campaigns and social media ad campaigns

const SOURCE_STORAGE_KEY = 'qr_source';

/**
 * Get campaign ID from URL parameters
 */
export function getCampaignFromURL(): string | null {
  if (typeof window === 'undefined') return null;

  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('campaign');
}

/**
 * Get source from URL parameters. Rudi printed practice QR codes as
 * `?practice=<slug>` until 2026-10; those count under their slug.
 */
export function getSourceFromURL(): string | null {
  if (typeof window === 'undefined') return null;

  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('source') || urlParams.get('practice');
}

/**
 * Store source in localStorage
 */
export function storeSource(source: string): void {
  if (typeof window !== 'undefined') {
    localStorage.setItem(SOURCE_STORAGE_KEY, source);
  }
}

/**
 * Get stored source from localStorage
 */
export function getStoredSource(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(SOURCE_STORAGE_KEY);
}

/**
 * Initialize source tracking - call this on app load
 * Returns the source that should be used (from URL or storage)
 */
export function initializeSourceTracking(): string | null {
  const urlSource = getSourceFromURL();

  if (urlSource) {
    // New source from URL, store it
    storeSource(urlSource);

    // Clean URL to remove source parameter (keep other params if any)
    const url = new URL(window.location.href);
    url.searchParams.delete('source');
    url.searchParams.delete('practice');
    window.history.replaceState(
      window.history.state, '', url.pathname + url.search + url.hash,
    );

    return urlSource;
  }

  // No URL source, check if we have a stored one
  return getStoredSource();
}

/**
 * Clear stored source (e.g., for testing or reset)
 */
export function clearStoredSource(): void {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(SOURCE_STORAGE_KEY);
  }
}
